import Message from './message'


const MessagePlugin = {
  install(Vue) {
    Vue.prototype.$message = Message
  }
}

export default MessagePlugin